import { AuthConsumer } from 'providers/authProvider'
import LoadingScreen from 'components/loading-screen';

export const LogoutCallback = () => (
    <AuthConsumer>
        {({ signoutRedirectCallback }) => {
            signoutRedirectCallback();
            return <LoadingScreen />
        }}
    </AuthConsumer>
)
